module.exports = __webpack_public_path__ + "static/media/img6.21aac227.png";